import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={15.488}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 12356 20504"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974541150320">
        <path
          d="M1610 3762s-107 778 411 778c517 0 410-778 410-778h-821z"
          className="fil0"
        />
        <path
          d="M12274 3386c-252-62-1002-297-1096-946-70-486-391-634-663-670-13-224-86-849-527-1297C9679 159 9258 0 8737 0c-500 0-901 158-1193 469-529 566-497 1435-492 1526v3418h-443v-734h-862v734h-444V1995c5-91 38-960-492-1526C4520 158 4119 0 3619 0c-521 0-942 159-1251 473-442 448-515 1073-527 1297-272 36-593 184-664 670-94 649-843 884-1095 946-48 11-82 54-82 104v73c0 60 48 108 107 108h3827c60 0 108-48 108-108v-73c0-50-34-93-82-104-252-62-1001-297-1096-946-69-482-386-632-657-669 13-192 79-698 422-1044 238-241 571-363 990-363 394 0 706 119 926 353 439 467 395 1253 395 1261l-1 3435h-247v365h247v1318h-247v364h1054v13044h863V7460h1055v-364h-248V5778h248v-365h-248V1978c-1-8-47-789 394-1260 220-235 532-354 927-354 419 0 752 122 990 363 342 346 409 852 422 1044-271 37-588 187-658 669-94 649-843 885-1095 946-48 12-82 55-82 104v74c0 59 48 107 108 107h3827c59 0 107-48 107-107v-74c0-50-34-92-82-104zM5303 7096V5778h444v1318h-444zm1749 0h-443V5778h443v1318z"
          className="fil0"
        />
        <path
          d="M9925 3762s-108 778 410 778c517 0 410-778 410-778h-820z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
